<div *ngIf="formSpec" attr-data-test="lm-form-standard">
  <lm-form-layout
    [formSpec]="formSpec"
    [formOptions]="formOptions"
    [specFields]="specFields"
    [layout]="layout"
    [model]="model"
    [formState]="formState"
    [placeHolder]="placeHolder"
    [activatedTabChanged]="activatedTabChanged"
    [formPersonalization]="formPersonalization"
    [parentIsModal]="parentIsModal"
    (fieldEvent)="onFieldEvent($event)"
  ></lm-form-layout>
</div>
<ng-content></ng-content>
